import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { getTeamOMSUsers } from "@redotech/redo-merchant-fulfillment-app/utils/get-team-oms-users";
import { SetAssignedUserActionStep } from "@redotech/redo-model/advanced-flow/oms/actions";
import { OMSUser } from "@redotech/redo-model/fulfillments/oms-user";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";
import { PartialWithRequiredType } from ".";

function userToListItem(user: OMSUser): RedoListItem<OMSUser> {
  return { id: user._id, value: user, type: "text", text: user.name };
}

export const UserDropdownInput = memo(function UserDropdownInput({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetAssignedUserActionStep>;
  setStep: (step: PartialWithRequiredType<SetAssignedUserActionStep>) => void;
}) {
  const team = useRequiredContext(TeamContext);
  const teamUsers = getTeamOMSUsers(team);

  const userOptions: RedoListItem<OMSUser>[] = useMemo(() => {
    if (!teamUsers || teamUsers.length === 0) {
      return [];
    }

    return teamUsers.map(userToListItem);
  }, [teamUsers]);

  const setAssignedUser = useHandler(
    ({ item }: { item: RedoListItem<OMSUser> }) => {
      setStep({ ...step, userId: item.value._id });
    },
  );

  return (
    <RedoSingleSelectDropdownInput
      fitToAnchor={false}
      flexGrow={false}
      options={userOptions}
      optionSelected={setAssignedUser}
      placeholder="Select user"
      selectedItem={userOptions.find((u) => u.value._id === step.userId)}
      size="xs"
    />
  );
});
